// extracted by mini-css-extract-plugin
module.exports = {"styles":"_3o0fX2Hm0lXcFBMG6QAb36"};